import { PurchaseOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0825.  発注案件契約タスク関連案件チェック済更新
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id/update_related_order_checked
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  related_order_checked: boolean;
};

const updateRelatedOrderChecked = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}/update_related_order_checked`,
    props
  );
};

export const useUpdateRelatedOrderChecked = () => {
  return useMutation({
    mutationFn: updateRelatedOrderChecked,
  });
};
